
export const isInvestor = function() {
    let investor = false;
    let user = JSON.parse(localStorage.getItem('me'));
    if(user.role_permissions.id == 3) {
       return investor = true;
    }
    return investor;
};

export default isInvestor;